import { NgModule } from '@angular/core';

import { DclDatesService } from './dates.service';

@NgModule({
    providers: [DclDatesService]
})
export class DclDatesModule {}
